import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    cursor: 'pointer'
  },

  icon: {
    fontSize: theme.size.base
  },

  count: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    transform: 'translateX(50%) translateY(-50%)'
  },

  dot: {
    position: 'absolute',
    top: '0',
    left: '12px',
    backgroundColor: '#EB5757',
    border: 'solid 1.5px white'
  },

  iconBtn: {
    padding: 4
  },

  titleArea: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: 'calc(100% - 48px)',
    padding: '24px 24px 0 24px',

    '& > :first-child': {
      marginBottom: '16px'
    },

    '& .row': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },

    '& .title': {
      fontSize: theme.size.xl,
      color: '#1F1F1F'
    },

    '& .closeIcon': {
      cursor: 'pointer',
      padding: 2
    },

    '& .tabs': {
      display: 'flex',
      alignItems: 'center',

      '& > :not(:last-child)': {
        marginRight: '8px'
      }
    },

    '& .separator': {
      margin: '12px auto 0 auto',
      borderTop: '1px solid #F0F0F0',
      width: 'calc(100% - 48px)'
    }
  }
}))

export default useStyles
